import { render, staticRenderFns } from "./AddOfferItem.vue?vue&type=template&id=0d4c581e&scoped=true"
import script from "./AddOfferItem.vue?vue&type=script&lang=ts"
export * from "./AddOfferItem.vue?vue&type=script&lang=ts"
import style0 from "./AddOfferItem.vue?vue&type=style&index=0&id=0d4c581e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c581e",
  null
  
)

export default component.exports